import { createApp } from 'vue'
import { vMaska } from 'maska/vue'
import vSelect from 'vue-select'
import { createPinia } from 'pinia'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { IconDefinition, library } from '@fortawesome/fontawesome-svg-core'
import App from './App.vue'
import { router } from './router'
import 'vue-select/dist/vue-select.css'
import icons from './helpers/icons'
import components from './components'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import config from '../config'

icons.forEach((icon) => {
  library.add(icon as IconDefinition)
})

const app = createApp(App)

Object.entries(components).forEach(([key, value]: any) => {
  app.component(key, value)
})

app.use(createPinia())

app.use(router)

// Maska 3.x: registrar diretiva globalmente
app.directive('maska', vMaska)

app.use(VueReCaptcha, {
  siteKey: config.app.reCaptchaSiKey,
  loaderOptions: {
    autoHideBadge: true,
    useRecaptchaNet: false,
  },
})

app.component('VSelect', vSelect)

app.component('FontAwesomeIcon', FontAwesomeIcon)

app.mount('#app')
